import type { CityConfig } from "../city-template/types";

export const commerceCityConfig: CityConfig = {
  city: "Commerce City",
  state: "Colorado",
  stateAbbr: "CO",
  slug: "commerce-city",
  route: "/cities/commerce-city",
  title: "Emergency & Expedited Passport Commerce City CO | Same-Day Adams County | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Commerce City, Colorado — as fast as 24 hours. Same-day courier processing for Commerce City, Reunion, Brighton, Henderson, and all northern Adams County travelers. A+ BBB rated, registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Commerce City, CO",
  heroSubtitle: "Last-minute international trip from DIA and your passport isn't ready? Soccer tournament in Mexico and you need documents fast? We help Commerce City residents — from Reunion families to Derby industrial professionals to Buffalo Run golfers — get their passports quickly. As a registered U.S. Department of State courier, we offer a best price guarantee and rates typically 30–100% lower than other passport courier resellers. As fast as 24 hours. A+ BBB rated.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Commerce%20City%20Colorado%20suburban%20landscape%20with%20the%20Rocky%20Mountain%20Arsenal%20National%20Wildlife%20Refuge%20and%20its%20vast%20prairie%20grasslands%2C%20bison%20herds%20grazing%20with%20the%20Denver%20skyline%20in%20the%20distant%20background%2C%20the%20Reunion%20community%20with%20modern%20homes%20and%20parks%2C%20the%20South%20Platte%20River%20corridor%20with%20golden%20cottonwood%20trees%2C%20warm%20late%20afternoon%20sunlight%20illuminating%20the%20prairie%20landscape%2C%20professional%20landscape%20photography%2C%20no%20visible%20text%20or%20people%2C%20wide%20cinematic%20view%20with%20natural%20tones&width=1800&height=700&seq=commercecity-hero-001&orientation=landscape",
  heroImageAlt: "Commerce City Colorado with Rocky Mountain Arsenal Wildlife Refuge and prairie landscapes",
  geoPosition: "39.8472;-104.8958",
  geoPlacename: "Commerce City, Colorado",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "3151 S. Vaughn Way, Aurora, CO 80014",
    distance: "Approximately 20 miles southeast via I-270 and I-225 — about 25–30 minutes",
  },
  nearbyCitiesZips: [
    { name: "Commerce City", zips: "80022, 80037" },
    { name: "Brighton", zips: "80601, 80602, 80603" },
    { name: "Reunion", zips: "80602" },
    { name: "Henderson", zips: "80640" },
    { name: "Thornton", zips: "80241, 80602" },
    { name: "Northglenn", zips: "80233, 80234, 80260" },
    { name: "Denver", zips: "80216, 80239" },
    { name: "Aurora", zips: "80010, 80011, 80012" },
    { name: "Dupont", zips: "80024" },
    { name: "Irondale", zips: "80022" },
    { name: "Derby", zips: "80022" },
    { name: "Welby", zips: "80229" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier service for urgent Commerce City international departures via DEN" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved — skip the Aurora drive, we handle it all" },
    { icon: "ri-flight-takeoff-line", title: "DIA 15 Minutes Away", desc: "Commerce City is one of the closest communities to Denver International Airport" },
    { icon: "ri-mail-send-line", title: "Overnight Shipping", desc: "Prepaid labels from any UPS or FedEx in Commerce City, Brighton, or Thornton" },
  ],
  internalLinks: [
    { name: "Expedited passport in Denver, CO", route: "/cities/denver" },
    { name: "Emergency passport help in Brighton, CO", route: "/cities/brighton" },
    { name: "Fast passport renewal in Commerce City area", route: "/cities/commerce-city" },
    { name: "Urgent passport services for Reunion and Henderson", route: "/cities/commerce-city" },
    { name: "Colorado passport services overview", route: "/states/colorado" },
    { name: "Passport courier services in Thornton and Northglenn", route: "/cities/thornton" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Commerce City remotely via secure registered courier. Our couriers hand-deliver your documents directly to U.S. Department of State processing facilities. Commerce City's prime location at the junction of I-76, I-270, and E-470 — just 15 minutes from Denver International Airport — makes our courier service incredibly efficient. Skip the drive through metro traffic and let us handle everything.",
  fpcOfficeAddress: "3151 S. Vaughn Way, Aurora, CO 80014",
  fpcOfficeDistance: "Serving all of Commerce City, northern Adams County, and the DIA corridor",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Commerce City and the surrounding northern Adams County area. From the growing Reunion community and Buffalo Run neighborhood to the industrial Derby district, from the neighborhoods near Dick's Sporting Goods Park to the communities along Highway 2 — we serve every corner of Commerce City.",
  nearbyCitiesIntro: "We serve Commerce City and all nearby communities including Brighton, Reunion, Henderson, Dupont, Irondale, Derby, Welby, Thornton, and Northglenn. We also serve southern Adams County and the DIA corridor.",
  howItWorksIntro: "Most Commerce City travelers complete everything online and ship documents via overnight courier. Our registered couriers handle the State Department delivery — you never need to battle I-270 and I-225 traffic to Aurora.",
  mistakesIntro: "Commerce City is an industrial and residential hub with families, soccer fans, and DIA-proximate travelers. Here are the most common passport mistakes we see from Commerce City-area travelers.",
  testimonialsIntro: "Commerce City travelers — from Reunion families to Derby business professionals to Rapids fans — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Commerce City, CO? Here are the most common ones we hear from Adams County travelers.",
  statePageRoute: "/states/colorado",
  statePageName: "Colorado",
  dmvWebsite: "https://dmv.colorado.gov",
  dmvLabel: "Colorado DMV — Official Website",
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Colorado Vital Records (Birth, Death, Marriage)", href: "https://cdphe.colorado.gov/certificates-and-records" },
    { label: "Adams County Clerk & Recorder", href: "https://www.adamscountyco.gov/240/Clerk-Recorder" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Aurora (25–30 minutes each way)", "I-270/I-225 corridor traffic is unpredictable"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Aurora drive required — ship from Commerce City", "Perfect for last-minute DIA international departures", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned family travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Commerce City travelers with immediate departure needs — as fast as 24 hours. Our couriers provide the fastest service available without fighting I-270 traffic to Aurora.",
      bullets: ["24–48 hour turnaround available", "DIA (DEN) departure support — just 15 minutes away", "Business and leisure travel expertise"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Commerce City adults with a passport issued within the last 15 years. Skip the post office and let our couriers handle everything.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Commerce City address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Commerce City residents and Adams County families — including Reunion newcomers and young adults.",
      bullets: ["Acceptance facility scheduling in Commerce City or Brighton", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Commerce City residents who lost their passport before international travel — business or personal.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Commerce City and Reunion families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Commerce City and Adams County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Commerce City CO", description: "Urgent passport processing for Commerce City Colorado travelers with immediate departure needs from DEN." },
    { name: "Expedited Passport Renewal Commerce City CO", description: "Fast passport renewal for Commerce City Colorado residents with a previously-issued passport." },
    { name: "First-Time Passport Commerce City CO", description: "New passport application services for Commerce City Colorado residents applying for their first passport." },
    { name: "Child Passport Commerce City CO", description: "Minor passport services for Commerce City Colorado families with children under 16." },
  ],
  testimonials: [
    {
      name: "Carlos M.",
      location: "Commerce City, CO — Reunion",
      rating: 5,
      text: "Family trip to Puerto Vallarta and my son's passport had expired. Fast Passport Center handled the renewal in 4 days. With DIA 15 minutes from our house, we were able to pack and go with zero stress.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Sandra K.",
      location: "Commerce City, CO — Buffalo Run",
      rating: 5,
      text: "Last-minute business conference in Frankfurt. Discovered my passport was damaged on a Monday, had a new one by Thursday. Being so close to DIA, the turnaround was amazing.",
      service: "Emergency Passport Replacement",
    },
    {
      name: "Robert J.",
      location: "Commerce City, CO — Derby",
      rating: 5,
      text: "Needed passports for my whole crew heading to a job site in Calgary. Fast Passport Center got three new passports done in 5 days. Industrial business travelers — this is the service you need.",
      service: "Business Passport Bundle",
    },
    {
      name: "Lisa T.",
      location: "Henderson, CO",
      rating: 5,
      text: "My passport was expiring 3 months before our anniversary trip to Italy. Fast Passport Center handled the renewal quickly and kept me updated every step. No need to deal with Denver traffic.",
      service: "Expedited Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "cc-1",
      name: "Commerce City Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7351 Magnolia St",
      city: "Commerce City",
      state: "CO",
      zip: "80022",
      phone: "(303) 288-2725",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Central Commerce City, near Highway 2 and 72nd Avenue",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Commerce City acceptance facility. Appointments recommended. Serves the Derby, Irondale, and central Commerce City areas.",
      icon: "ri-mail-line",
    },
    {
      id: "cc-2",
      name: "Brighton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "90 N 4th Ave",
      city: "Brighton",
      state: "CO",
      zip: "80601",
      phone: "(303) 659-3033",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Approximately 10 miles north of Commerce City, in downtown Brighton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Larger facility serving the northern corridor. Good alternative when Commerce City appointments are full. Near the Adams County Courthouse.",
      icon: "ri-mail-line",
    },
    {
      id: "cc-3",
      name: "Thornton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "8700 Grant St",
      city: "Thornton",
      state: "CO",
      zip: "80229",
      phone: "(303) 853-9940",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Approximately 10 miles west of Commerce City, in Thornton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Extended hours compared to Commerce City. Good option for western Commerce City and Welby residents. Larger facility with more appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "cc-4",
      name: "Adams County Clerk & Recorder",
      type: "County Clerk Passport Acceptance",
      address: "4430 S Adams County Pkwy",
      city: "Brighton",
      state: "CO",
      zip: "80601",
      phone: "(720) 523-6100",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Approximately 10 miles north of Commerce City, in Brighton",
      website: "https://www.adamscountyco.gov/",
      websiteLabel: "Adams County Clerk",
      notes: "County government passport acceptance at the Adams County Government Center. Early morning hours available. Serves all Adams County residents.",
      icon: "ri-government-line",
    },
    {
      id: "cc-5",
      name: "Northglenn Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "11887 Washington St",
      city: "Northglenn",
      state: "CO",
      zip: "80233",
      phone: "(303) 451-1666",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Approximately 10 miles west of Commerce City, in Northglenn",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Western acceptance facility for the Commerce City-Northglenn corridor. Convenient for residents near Highway 2 and 104th Avenue.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 20-mile drive to Aurora via I-270/I-225", fpc: "No — ship from Commerce City" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "DIA Proximity Advantage", agency: "No benefit — still must go to Aurora", fpc: "Ship from Commerce City — 15 minutes from DIA" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Assuming Proximity to DIA Solves Everything",
      description: "Living 15 minutes from Denver International Airport is convenient, but DIA has no passport processing services. You still need an acceptance facility or expedited courier. Don't wait until you're at the airport.",
    },
    {
      icon: "ri-image-line",
      title: "Using Non-Compliant Photos",
      description: "Commerce City photo services at grocery stores and pharmacies may not follow strict U.S. Department of State requirements. Passport photos must be exactly 2×2 inches on a white or off-white background with no shadows or glare.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Skipping Appointment Booking",
      description: "Commerce City Post Office is a smaller facility with limited passport appointment slots. During peak travel seasons, appointments fill 2–3 weeks in advance. Book early or use nearby Brighton or Thornton facilities.",
    },
    {
      icon: "ri-car-line",
      title: "Underestimating I-270/I-225 Traffic",
      description: "The drive from Commerce City to the Aurora passport agency requires navigating the I-270/I-225 interchange — one of metro Denver's busiest corridors. Rush hour can easily turn a 25-minute drive into 50+ minutes.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking Passport Validity Requirements",
      description: "Many countries require 6 months of passport validity beyond your stay. Commerce City business travelers heading to Canada or Mexico often discover this requirement at the last minute.",
    },
    {
      icon: "ri-file-warning-line",
      title: "Forgetting DS-11 Requirements for First-Timers",
      description: "First-time passport applicants in Commerce City must appear in person at an acceptance facility — no exceptions. Many residents don't realize this and show up without the proper forms and documentation.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Commerce City or Adams County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Commerce City, Brighton, or Thornton." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for Adams County documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to State Department facilities — no I-270/I-225 traffic battle required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Commerce City address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Commerce City, CO?", a: "Fast Passport Center offers emergency passport processing in Commerce City, Colorado in as little as 24–48 hours. Our registered couriers hand-deliver your documents to U.S. Department of State facilities — no need to navigate the I-270/I-225 interchange to the Aurora passport agency." },
    { q: "Is DIA the closest airport for international travel from Commerce City?", a: "Yes — Denver International Airport (DEN) is approximately 15 minutes from Commerce City via E-470 or Tower Road. It's one of the closest major communities to DIA, making Commerce City incredibly convenient for international travelers." },
    { q: "Does Commerce City have its own passport acceptance facility?", a: "Yes — the Commerce City Post Office (7351 Magnolia St) offers passport acceptance services Monday through Friday. However, it's a smaller facility with limited appointments. Nearby Brighton and Thornton offer additional options with more availability." },
    { q: "What if I live in Reunion, Derby, or Irondale?", a: "Absolutely. Fast Passport Center serves all of Commerce City including Reunion, Derby, Irondale, Dupont, and the Buffalo Run area. Our service works the same way everywhere — ship your documents and we handle the rest from anywhere in the Commerce City area." },
    { q: "Can you help with passports for Rapids fans traveling internationally?", a: "Yes! Fast Passport Center serves all Commerce City residents including Colorado Rapids supporters heading to international matches or tournaments. With Dick's Sporting Goods Park right in Commerce City, we understand the soccer community's travel needs." },
    { q: "How much does an expedited passport cost in Commerce City, CO?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Commerce City?", a: "Walgreens locations in Commerce City and nearby Thornton offer passport photo services. King Soopers in Commerce City (4850 E 62nd Ave) also provides photos. UPS Store in Reunion and FedEx Office in Northglenn are additional options. Photos must be 2×2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve Commerce City business and industrial travelers?", a: "Yes. Fast Passport Center serves Commerce City's diverse workforce — from industrial and logistics professionals to corporate travelers. We understand the needs of business travelers with tight schedules and can coordinate expedited services to match your departure timeline." },
  ],
  photoLocations: [
    { name: "King Soopers — Commerce City", address: "4850 E 62nd Ave, Commerce City, CO 80022", hours: "Mon–Sun: 6AM–11PM", website: "https://www.kingsoopers.com/" },
    { name: "Walgreens — Commerce City", address: "5990 Dahlia St, Commerce City, CO 80022", hours: "Mon–Sun: 8AM–9PM", website: "https://www.walgreens.com/photo" },
    { name: "UPS Store — Reunion", address: "18240 E 104th Ave, Commerce City, CO 80022", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–3PM", website: "https://www.theupsstore.com/" },
    { name: "FedEx Office — Northglenn", address: "560 E 120th Ave, Northglenn, CO 80233", hours: "Mon–Fri: 7:30AM–7PM, Sat: 9AM–5PM", website: "https://www.office.fedex.com/" },
  ],
  dmvLocations: [
    { name: "DMV — Brighton (Adams County)", address: "4430 S Adams County Pkwy, Brighton, CO 80601", hours: "Mon–Fri: 8AM–5PM", note: "Full-service DMV at the Adams County Government Center. REAL ID and driver's license renewals. Approximately 10 miles north of Commerce City.", featured: true },
    { name: "DMV — Thornton (Adams County)", address: "11940 Colorado Blvd, Thornton, CO 80233", hours: "Mon–Fri: 8AM–5PM", note: "Alternative DMV in Thornton for western Commerce City residents. REAL ID processing available. Convenient I-25 access.", featured: false },
  ],
  airports: [
    {
      code: "DEN",
      name: "Denver International Airport",
      distance: "15 miles east via E-470 — approximately 15–20 minutes",
      address: "8500 Peña Blvd, Denver, CO 80249",
      note: "Colorado's primary international airport with nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Extremely convenient for Commerce City residents — one of the closest communities to DIA in the metro area.",
      flightUrl: "https://www.flydenver.com/",
      flightLabel: "DEN Flight Info",
      featured: true,
    },
    {
      code: "BJC",
      name: "Rocky Mountain Metropolitan Airport",
      distance: "20 miles west via US-36 — approximately 25–30 minutes",
      address: "11755 Airport Way, Broomfield, CO 80021",
      note: "General aviation and corporate airport serving the northern metro area. No scheduled commercial service. Private and charter flights only.",
      flightUrl: "https://www.flyrmm.com/",
      flightLabel: "BJC Flight Info",
      featured: false,
    },
  ],
};